// extracted by mini-css-extract-plugin
module.exports = {"container":"studio__container___2U_w5"};